<template>
  <div class="sw-page">
    <div class="sw-inner">
      <div class="sw-header">
        <span class="sw-header-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none">
            <rect x="2.5" y="6" width="19" height="14" rx="3" stroke="currentColor" stroke-width="2" />
            <path d="M2.5 10h19" stroke="currentColor" stroke-width="2" />
            <circle cx="17" cy="15" r="1.5" fill="currentColor" />
          </svg>
        </span>
        <h1 class="sw-title">选择钱包</h1>
      </div>

      <div class="sw-qr-card">
        <p class="sw-qr-tip">扫码支付或选择下面钱包</p>
        <div class="sw-qr-box">
          <canvas ref="qrCanvas" class="sw-qr-canvas" />
        </div>
      </div>

      <div class="sw-amount">
        支付金额:
        <span class="sw-amount-val">{{ displayAmount }} USDT</span>
      </div>

      <div class="sw-wallet-list">
        <div v-for="item in wallets" :key="item.value" class="sw-wallet-card">
          <div class="sw-wallet-left">
            <img v-if="item.src" :src="item.src" :alt="item.title" class="sw-wallet-icon" />
            <div v-else class="sw-wallet-icon sw-wallet-icon--onekey" aria-hidden="true">
              <span>1O</span>
            </div>
            <div class="sw-wallet-meta">
              <div class="sw-wallet-name">{{ item.title }}</div>
              <div class="sw-wallet-sub">快捷支付：TRC-20</div>
            </div>
          </div>
          <button type="button" class="sw-select-btn" @click="onSelect(item)">选择</button>
        </div>
      </div>

      <div class="sw-notice">
        请确保您的钱包余额充足，并选择合适的网络 (TRC-20) 进行支付。
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode';
import {
  buildWalletPayUrl,
  openWalletPayDeeplink,
  resolveReferralContext,
} from '../util/deeplink';
import { persistWalletClientChoice } from '../util/walletClient';
import { readSelectWalletOrder } from '../util/paymentFlow';

export default {
  name: 'SelectWallet',
  data() {
    return {
      amount: 300,
      orderNo: '',
      referralCode: '',
      gameGroupId: '',
      orderPayload: null,
      // 与 Payment / TgPayment 一致的 4 种可深链钱包
      wallets: [
        { title: 'imToken', src: require('../assets/imtoken.jpg'), value: 'imtoken' },
        { title: 'TokenPocket', src: require('../assets/tokenpocket.jpg'), value: 'tokenpocket' },
        { title: 'Bitget', src: require('../assets/bitget.jpg'), value: 'bitget' },
        { title: 'TronLink', src: require('../assets/tronlink.jpg'), value: 'tronlink' },
      ],
    };
  },
  computed: {
    displayAmount() {
      const n = Number(this.amount) || 0;
      if (!n) return '0.0';
      return n % 1 === 0 ? `${n}.0` : String(Number(n.toFixed(4)));
    },
    qrPayload() {
      if (this.orderNo && this.referralCode) {
        // 扫码直接打开 DApp HTTPS（非钱包协议）；路径 tgNo = orderNo
        return buildWalletPayUrl(this.orderNo, this.referralCode, {
          gameGroupId: this.gameGroupId,
        });
      }
      return JSON.stringify({
        type: 'USDT-TRC20',
        amount: Number(this.amount) || 0,
        orderNo: this.orderNo || '',
      });
    },
  },
  watch: {
    qrPayload() {
      this.renderQr();
    },
  },
  mounted() {
    const ctx = resolveReferralContext(this.$route);
    const cached = readSelectWalletOrder() || {};
    const q = this.$route.query || {};

    this.orderPayload = cached;
    this.orderNo = String(q.orderNo || cached.orderNo || '');
    this.referralCode = String(q.code || cached.referral_code || ctx.referralCode || '');
    this.gameGroupId = String(q.gid || cached.gameGroupId || cached.gid || ctx.gameGroupId || '');

    const amountRaw = q.amount ?? (cached.price != null
      ? Number(cached.price) * Number(cached.inputNumber || 1)
      : null);
    if (amountRaw != null && amountRaw !== '') {
      const n = Number(amountRaw);
      if (!Number.isNaN(n) && n > 0) this.amount = n;
    }

    this.$nextTick(() => this.renderQr());
  },
  methods: {
    async renderQr() {
      const canvas = this.$refs.qrCanvas;
      if (!canvas) return;
      try {
        await QRCode.toCanvas(canvas, this.qrPayload, {
          width: 220,
          margin: 1,
          color: { dark: '#000000', light: '#ffffff' },
        });
      } catch (e) {
        console.error(e);
      }
    },
    onSelect(item) {
      persistWalletClientChoice(item.value);

      if (!this.orderNo || !this.referralCode) {
        // 无订单时不处理余额到账，仅回订单大厅
        this.$router.push({ name: 'OrderHall' });
        return;
      }

      // 与旧支付页一致：钱包 App 协议深链打开 WalletPay（路径 tgNo 实为 orderNo）
      openWalletPayDeeplink(
        item.value,
        this.orderNo,
        this.referralCode,
        this.gameGroupId || undefined,
      );
    },
  },
};
</script>

<style scoped>
.sw-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: #f4f6f9;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  color: #1a2a3a;
}

.sw-inner {
  max-width: 480px;
  margin: 0 auto;
  padding: 18px 16px 40px;
  box-sizing: border-box;
}

.sw-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.sw-header-icon {
  display: inline-flex;
  color: #1e3a5f;
}

.sw-title {
  margin: 0;
  font-size: 22px;
  font-weight: 800;
  color: #1e3a5f;
}

.sw-qr-card {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 4px 18px rgba(20, 40, 80, 0.06);
  padding: 18px 16px 22px;
  text-align: center;
}

.sw-qr-tip {
  margin: 0 0 14px;
  font-size: 15px;
  font-weight: 600;
  color: #5a6a7a;
}

.sw-qr-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding: 8px;
  border-radius: 8px;
}

.sw-qr-canvas {
  display: block;
  width: 220px;
  height: 220px;
  max-width: 70vw;
  max-height: 70vw;
}

.sw-amount {
  margin: 16px 4px 14px;
  font-size: 15px;
  font-weight: 600;
  color: #333;
}

.sw-amount-val {
  color: #f05a28;
  font-weight: 800;
}

.sw-wallet-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.sw-wallet-card {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 4px 16px rgba(20, 40, 80, 0.05);
  padding: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.sw-wallet-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.sw-wallet-icon {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  object-fit: cover;
  flex-shrink: 0;
  background: #eef2f6;
}

.sw-wallet-icon--onekey {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #00e096;
  color: #111;
  font-weight: 900;
  font-size: 16px;
}

.sw-wallet-meta {
  min-width: 0;
}

.sw-wallet-name {
  font-size: 17px;
  font-weight: 800;
  color: #1a2a3a;
  line-height: 1.2;
}

.sw-wallet-sub {
  margin-top: 4px;
  font-size: 12px;
  font-weight: 600;
  color: #8a97a6;
}

.sw-select-btn {
  flex-shrink: 0;
  height: 34px;
  padding: 0 18px;
  border: 0;
  border-radius: 999px;
  background: #3aa0d9;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.sw-notice {
  margin-top: 16px;
  background: #e8ebef;
  border-radius: 12px;
  padding: 14px 16px;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  color: #5a6570;
  line-height: 1.6;
}

@media (max-width: 380px) {
  .sw-title {
    font-size: 20px;
  }
  .sw-wallet-name {
    font-size: 15px;
  }
  .sw-wallet-icon {
    width: 44px;
    height: 44px;
  }
}
</style>
